import { Star, ExternalLink } from "lucide-react";

export const GOOGLE_REVIEWS_URL =
  "https://g.page/r/CYdMn1Dq3xR_EAI/review";

export const GoogleReviewsBadge = ({ size = "md", className = "" }) => {
  const isLarge = size === "lg";
  return (
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`group inline-flex items-center gap-3 border border-neutral-700 bg-neutral-900/60 backdrop-blur-sm px-5 py-3 hover:border-white hover:bg-neutral-800 transition-colors duration-200 ${className}`}
      data-testid="google-reviews-badge"
    >
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`${isLarge ? "w-5 h-5" : "w-4 h-4"} fill-yellow-400 text-yellow-400`}
          />
        ))}
      </div>
      <div className="h-6 w-px bg-neutral-700" />
      <p
        className={`${
          isLarge ? "text-sm" : "text-xs"
        } uppercase tracking-widest text-white font-medium`}
      >
        5.0 · 80+ Reviews
      </p>
      <span
        className={`${
          isLarge ? "text-xs" : "text-[10px]"
        } text-gray-400 group-hover:text-white transition-colors uppercase tracking-widest hidden sm:inline`}
      >
        Read on Google
      </span>
      <ExternalLink
        className={`${
          isLarge ? "w-4 h-4" : "w-3.5 h-3.5"
        } text-gray-400 group-hover:text-white transition-colors`}
      />
    </a>
  );
};

export default GoogleReviewsBadge;
